import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import * as XLSX from 'xlsx';

@Injectable({providedIn: 'root'})
export class CopyPasteExcelService {
  private readonly parsedExcelData = new BehaviorSubject<any>(null);
  private readonly isDisplayTable: Subject<boolean> = new Subject();
  private readonly isClearTextArea: Subject<boolean> = new Subject();
  private readonly excelFile = new BehaviorSubject<any>(null);

  constructor() {}

  setParsedExcelData(data: any) {
    this.parsedExcelData.next(data);
  }

  getParsedExcelData() {
    return this.parsedExcelData.asObservable();
  }

  setIsDisplayTable(value: boolean) {
    this.isDisplayTable.next(value);
  }

  getIsDisplayTable() {
    return this.isDisplayTable.asObservable();
  }

  setIsClearTextArea() {
    this.isClearTextArea.next(true);
  }

  getIsClearTextArea() {
    return this.isClearTextArea.asObservable();
  }

  setExcelFile(file: Blob) {
    this.excelFile.next(file);
  }

  getExcelFile() {
    const rows = this.parsedExcelData.getValue();
    if (!rows.length) return;

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Data': worksheet },
      SheetNames: ['Data']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const firstSheetName = workbook.SheetNames[0];

    this.excelFile.next({fileBlob: blob, sheetName: firstSheetName, rowsAmount: rows.length + 1});
    return this.excelFile.asObservable();
  }
}
